<template>
  <div>
    <v-row align="center" class="pa-4 mb-2">
      <v-card-title>Белый список телефонных номеров</v-card-title>
      <div>
        <BaseTextField
          v-model="phoneSearch"
          type-input="string"
          :is-button="false"
          label="Номер телефона"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="dialogNew = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-new-box</v-icon>
          </v-btn>
        </template>
        <span>Создать номер</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="popupImport = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-application-import</v-icon>
          </v-btn>
        </template>
        <span>Импорт номеров</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="handleExport"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="loadWhitePhoneNumbers"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col
        v-if="resResidentComplex.barriers && resResidentComplex.barriers.length > 0"
        cols="12"
        class="ma-4 mt-0 pt-0"
      >
        <v-chip v-for="barrier in resResidentComplex.barriers" :key="barrier.id" class="mr-2 mb-2">
          id: {{ barrier.id }}, адрес: {{ barrier.address }}
          <span v-if="!barrier.device_id">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  width="18"
                  height="18"
                >
                  <v-icon x-small color="orange">mdi-checkbox-blank-circle</v-icon>
                </v-btn>
              </template>
              <span>Старый шлагбаум</span>
            </v-tooltip>
          </span>
        </v-chip>
      </v-col>
    </v-row>

    <!-- Диалог создания -->
    <v-dialog v-model="dialogNew" max-width="650" content-class="dialog-border-radius">
      <create-white-phone-number
        :active.sync="dialogNew"
        icon="mdi-phone-check"
        message="Новый номер в белом списке"
        @save="handleSave"
        @close="closeDialog"
      />
    </v-dialog>

    <!-- Диалог импорта -->
    <v-dialog v-model="popupImport" max-width="500" content-class="dialog-border-radius">
      <v-card class="border">
        <v-card-title class="card-header" style="box-shadow: none;">
          <span class="text-h5">Импорт белого списка</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="popupImport = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-col cols="11" class="py-0 mt-4">
            <v-file-input
              v-model="importFile"
              accept=".csv"
              outlined
              dense
              flat
              label="Файл с номерами"
              :rules="[value => !!value || 'Обязательное поле']"
              append-icon="mdi-information-outline"
              @click:append="infoImportUpload = !infoImportUpload"
            ></v-file-input>
            <v-col
              v-if="!infoImportUpload"
              class="ml-5 pt-0"
            >
              <p>Формат файла: CSV</p>
              <p>Кодировка файла должна быть: Юникод (UTF-8)</p>
              <p>Формат: телефон, имя (необязательно), id домофона (необязательно), номер кв (необязательно)</p>
            </v-col>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              large
              color="success"
              class="text-none"
              dense
              :disabled="importFile === null"
              @click.prevent="handleImport"
            >
              Импортировать
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Результат импорта-->
    <v-dialog v-model="resultDialog" max-width="700px" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Результат <span style="color: #388E3C; padding-left: 5px; padding-right: 5px">{{ action }}</span> номеров
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(result, index) in results" :key="index">
              <v-list-item-content>
                <v-list-item-title>id: {{ result.id }}, адрес: {{ result.address }}</v-list-item-title>
                <v-list-item-subtitle :class="result.success ? 'text-success' : 'text-error'">
                  <div v-if="result.message">
                    {{ result.message }}
                  </div>
                  <div v-else-if="result.error">
                    {{ result.error }}
                  </div>
                  <div v-else>
                    {{ result.success ? 'Успешно' : 'Ошибка.' }}
                  </div>
                </v-list-item-subtitle>
                <div v-if="result.importedCount !== undefined || result.skippedCount !== undefined" class="mt-2">
                  <div v-if="result.importedCount !== undefined">
                    <strong>Импортировано:</strong> {{ result.importedCount }}
                  </div>
                  <div v-if="result.skippedCount !== undefined">
                    <strong>Пропущено:</strong> {{ result.skippedCount }}
                  </div>
                </div>
                <div v-if="result.errors && result.errors.length > 0" class="mt-2">
                  <div class="text-error">
                    <strong>Ошибки:</strong>
                    <ul style="margin-top: 5px; padding-left: 20px;">
                      <li v-for="(error, errorIndex) in result.errors" :key="errorIndex" style="margin-bottom: 3px;">
                        {{ error }}
                      </li>
                    </ul>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="resultDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог удаления -->
    <v-dialog v-model="showDeleteDialog" max-width="400" content-class="dialog-border-radius">
      <baseDeleteModal
        :active.sync="showDeleteDialog"
        @close="showDeleteDialog = false"
        @submit="deleteSelectedItems"
        messageTitle="Удалить номера?"
        messageText="Подтверждая, вы удалите выбранные номера из белого списка всех шлагбаумов жилого комплекса."
      />
    </v-dialog>

    <v-data-table
      class="table"
      :headers="headersTable"
      :items="filtered"
      item-key="uniqueId"
      :footer-props="{ showFirstLastPage: true }"
    >
<!--      <template v-slot:header.is_blocked>-->
<!--        Статус-->
<!--        <v-tooltip bottom>-->
<!--          <template v-slot:activator="{ on, attrs }">-->
<!--            <v-btn-->
<!--              icon-->
<!--              v-bind="attrs"-->
<!--              v-on="on"-->
<!--              text-->
<!--              x-large-->
<!--              style="cursor: default;"-->
<!--              class="btn__icon pa-0 ml-4"-->
<!--              width="18"-->
<!--              height="18"-->
<!--            >-->
<!--              <v-icon size="x-large">mdi-chat-question-outline</v-icon>-->
<!--            </v-btn>-->
<!--          </template>-->
<!--          <span>По нажатию на статус вы можете изменить состояние телефонного номера.</span>-->
<!--        </v-tooltip>-->
<!--      </template>-->
      <template v-slot:item.barrierInfo="{ item }">
        <router-link class="routerLink" :to="`/barrier/${item.barrierId}`">
          {{ item.barrierAddress }}
        </router-link>
      </template>
      <template v-slot:item.phone_number="{ item }">
        {{ formatPhoneNumber(item.phone_number) }}
      </template>
      <template v-slot:item.is_blocked="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary darken-1"
              text
              style="cursor: auto"
            >
              <v-icon small :color="item.is_blocked ? 'orange' : 'green'">
                mdi-checkbox-blank-circle
              </v-icon>
            </v-btn>
          </template>
          <span v-if="item.is_blocked">Заблокирован</span>
          <span v-else>Активен</span>
        </v-tooltip>
      </template>
      <template v-slot:item.valid="{ item }">
        <div v-if="item.valid_from">
          {{ formatDate(item.valid_from) }} - {{ formatDate(item.valid_until) }}
        </div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                v-bind="attrs"
                v-on="on"
                tile
                small
                class="btn__icon ml-4 mr-1"
                width="18"
                height="18"
                @click.stop="$set(dialogWarning, item.uniqueId, true)"
              >
                <v-icon size="large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
          <v-dialog v-model="dialogWarning[item.uniqueId]" max-width="400" content-class="dialog-border-radius">
            <baseDeleteModal
              :active.sync="dialogWarning[item.uniqueId]"
              @close="$set(dialogWarning, item.uniqueId, false)"
              @submit="deleteItem(item)"
              messageTitle="Удалить номер?"
              messageText="Подтверждая, вы удалите номер из белого списка всех шлагбаумов жилого комплекса."
            />
          </v-dialog>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import baseDeleteModal from '@/components/BaseDeleteModal';
import BaseTextField from '../../BaseTextField';
import formatPhoneNumber from '../../../mixins/formatPhoneNumber';
import formatPhoneNumberTextField from '../../../mixins/formatPhoneNumberTextField';
import CreateWhitePhoneNumber from '@/components/barrier/DetailBarrier/components/CreateWhitePhoneNumber';

export default {
  name: 'WhitePhoneNumbersResComplex',
  mixins: [ruDateFormatMixin, formatPhoneNumber, formatPhoneNumberTextField],
  components: { baseDeleteModal, BaseTextField, CreateWhitePhoneNumber },
  data () {
    return {
      whitePhoneNumbers: [],
      selectedItems: [],
      phoneSearch: '',
      dialogNew: false,
      popupImport: false,
      showDeleteDialog: false,
      dialogWarning: {},
      importFile: null,
      infoImportUpload: false,
      resResidentComplex: {},
      results: [],
      resultDialog: false,
      action: '',
      headersTable: [
        { text: 'Основной шлагбаум', value: 'barrierInfo', align: 'center', width: '25%' },
        { text: 'Телефон', value: 'phone_number', sortable: false },
        { text: 'Имя', value: 'full_name', sortable: false },
        { text: 'Адрес', value: 'address' },
        { text: 'Квартира', value: 'apartment', sortable: false },
        { text: 'Статус', value: 'is_blocked', sortable: false },
        { text: 'Промежуток дейсвия номера', value: 'valid', sortable: false },
        { text: '', value: 'action', sortable: false, width: '100px' },
      ],
    };
  },
  created () {
    this.getResidentComplex();
  },
  computed: {
    filtered () {
      if (this.phoneSearch) {
        const searchNormalized = String(this.phoneSearch).replace(/\D/g, '');

        return this.whitePhoneNumbers.filter(item => {
          if (item.phone_number === null) {
            return false;
          }

          const phoneNormalized = String(item.phone_number).replace(/\D/g, '');
          const phoneFormatted = this.formatPhoneNumber(item.phone_number);

          return phoneNormalized.includes(searchNormalized) ||
          phoneFormatted.toLowerCase().includes(this.phoneSearch.toLowerCase());
        });
      } else {
        return this.whitePhoneNumbers;
      }
    },
  },
  methods: {
    handlePhoneSearchInput (event) {
      const phoneValue = typeof event === 'string' ? event : (event.target?.value || event);
      this.phoneSearch = this.formatPhoneNumberTextField(phoneValue);
    },
    ...mapActions({
      getWhitePhoneNumbers: 'Barriers/getWhitePhoneNumbers',
      createWhitePhoneNumber: 'Barriers/createWhitePhoneNumber',
      updateWhitePhoneNumber: 'Barriers/updateWhitePhoneNumber',
      deleteWhitePhoneNumber: 'Barriers/deleteWhitePhoneNumber',
      importWhitePhoneNumbers: 'Barriers/importWhitePhoneNumbers',
      viewComplex: 'ResidentComplex/viewComplex',
    }),
    async getResidentComplex () {
      this.viewComplex(this.$route.params.id)
        .then(async (res) => {
          this.resResidentComplex = res;
          await this.loadWhitePhoneNumbers();
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при загрузке жилого комплекса');
        });
    },
    async loadWhitePhoneNumbers () {
      if (!this.resResidentComplex.barriers || this.resResidentComplex.barriers.length === 0) {
        return;
      }

      this.whitePhoneNumbers = [];
      const barriers = this.resResidentComplex.barriers;

      try {
        const promises = barriers.map(barrier =>
          this.getWhitePhoneNumbers({ barrierId: barrier.id })
            .then((response) => {
              const numbers = response.data || [];
              return numbers.map(number => ({
                ...number,
                barrierId: barrier.id,
                barrierAddress: barrier.address,
                uniqueId: `${barrier.id}-${number.id}`,
              }));
            })
            .catch((error) => {
              console.error(`Ошибка при загрузке белого списка для шлагбаума ${barrier.id}:`, error);
              return [];
            }),
        );

        const allNumbers = await Promise.all(promises);
        this.whitePhoneNumbers = allNumbers.flat();
      } catch (error) {
        console.error(error);
        this.$flash_warning('Ошибка при загрузке белого списка');
      }
    },
    closeDialog () {
      this.dialogNew = false;
    },
    async handleSave (phoneNumber, fullName, address, apartment, validFrom, validUntil) {
      const params = {
        phone_number: phoneNumber,
        full_name: fullName,
        address: address,
        apartment: apartment,
        valid_from: validFrom,
        valid_until: validUntil,
      };

      this.results = [];
      this.action = 'Создание';

      const barriers = this.resResidentComplex.barriers;

      for (const barrier of barriers) {
        try {
          await this.createWhitePhoneNumber({
            barrierId: barrier.id,
            params,
          });
          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: true,
          });
        } catch (error) {
          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: false,
            error: this.getErrorMessage(error),
          });
        }
      }

      await this.loadWhitePhoneNumbers();
      this.closeDialog();
      this.resultDialog = true;
      this.$flash_success('Операция завершена');
    },
    async deleteItem (item) {
      this.results = [];
      this.action = 'Удаление';

      const samePhoneNumbers = this.whitePhoneNumbers.filter(
        num => num.phone_number === item.phone_number,
      );

      for (const phoneNumber of samePhoneNumbers) {
        try {
          await this.deleteWhitePhoneNumber({
            barrierId: phoneNumber.barrierId,
            whitePhoneNumberId: phoneNumber.id,
          });
          this.results.push({
            id: phoneNumber.barrierId,
            address: phoneNumber.barrierAddress,
            success: true,
          });
        } catch (error) {
          if (!error.response || error.response.status !== 404) {
            this.results.push({
              id: phoneNumber.barrierId,
              address: phoneNumber.barrierAddress,
              success: false,
              error: this.getErrorMessage(error),
            });
          } else {
            this.results.push({
              id: phoneNumber.barrierId,
              address: phoneNumber.barrierAddress,
              success: true,
            });
          }
        }
      }

      await this.loadWhitePhoneNumbers();
      this.$set(this.dialogWarning, item.uniqueId, false);
      if (this.results.length > 0) {
        this.resultDialog = true;
      }
      this.$flash_success('Операция завершена');
    },
    deleteSelectedItems () {
      const promises = this.selectedItems.map(item => this.deleteItem(item));
      Promise.all(promises)
        .then(() => {
          this.selectedItems = [];
          this.showDeleteDialog = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showDeleteDialog = false;
        });
    },
    async toggleBlock (item) {
      const params = {
        phone_number: item.phone_number,
        full_name: item.full_name || null,
        address: item.address || null,
        apartment: item.apartment || null,
        valid_from: item.valid_from || null,
        valid_until: item.valid_until || null,
        is_blocked: !item.is_blocked,
      };

      try {
        await this.updateWhitePhoneNumber({
          barrierId: item.barrierId,
          whitePhoneNumberId: item.id,
          params,
        });
        this.$flash_success(item.is_blocked ? 'Номер разблокирован' : 'Номер заблокирован');
        await this.loadWhitePhoneNumbers();
      } catch (error) {
        this.handleError(error);
      }
    },
    async handleImport () {
      if (!this.importFile) {
        this.$flash_warning('Выберите файл для импорта');
        return;
      }

      this.results = [];
      this.action = 'Импорт';
      const barriers = this.resResidentComplex.barriers;

      for (const barrier of barriers) {
        try {
          const formData = new FormData();
          formData.append('csv_file', this.importFile);

          const response = await this.importWhitePhoneNumbers({
            barrierId: barrier.id,
            formData: formData,
          });

          const hasErrors = response.errors && response.errors.length > 0;
          const importedCount = response.imported_count || 0;
          const skippedCount = response.skipped_count || 0;
          const message = response.message || '';

          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: !hasErrors,
            message: message,
            importedCount: importedCount,
            skippedCount: skippedCount,
            errors: response.errors || [],
          });
        } catch (error) {
          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: false,
            error: this.getErrorMessage(error),
          });
        }
      }

      await this.loadWhitePhoneNumbers();
      this.popupImport = false;
      this.importFile = null;
      this.resultDialog = true;

      const hasAnyErrors = this.results.some(r => r.errors && r.errors.length > 0);
      if (hasAnyErrors) {
        this.$flash_warning('Импорт завершен с ошибками. Проверьте детали в результате.');
      } else {
        this.$flash_success('Операция завершена');
      }
    },
    handleExport () {
      try {
        const lines = [];

        const headers = [
          'Телефон',
          'Имя',
          'Адрес',
          'Квартира',
          'Статус',
          'Промежуток действия',
          'Шлагбаум (ID)',
          'Адрес шлагбаума',
        ];
        lines.push(headers.join(';'));

        this.whitePhoneNumbers.forEach((item) => {
          const phoneNumber = item.phone_number || '';
          const fullName = item.full_name || '';
          const address = item.address || '';
          const apartment = item.apartment || '';
          const status = item.is_blocked ? 'Заблокирован' : 'Активен';

          let validRange = '';
          if (item.valid_from && item.valid_until) {
            validRange = `${this.formatDate(item.valid_from)} - ${this.formatDate(item.valid_until)}`;
          } else if (item.valid_from) {
            validRange = this.formatDate(item.valid_from);
          } else if (item.valid_until) {
            validRange = this.formatDate(item.valid_until);
          }

          const barrierId = item.barrierId || '';
          const barrierAddress = item.barrierAddress || '';

          const line = [
            phoneNumber,
            fullName,
            address,
            apartment,
            status,
            validRange,
            barrierId,
            barrierAddress,
          ].join(';');

          lines.push(line);
        });

        const csvContent = lines.join('\n');
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `white-phone-numbers-res-complex-${this.$route.params.id}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.handleError(error);
      }
    },
    handleError (error) {
      if (error.response && error.response.data) {
        if (error.response.data.errors) {
          const errors = error.response.data.errors;
          for (const field in errors) {
            errors[field].forEach(err => this.$flash_warning(`${field}: ${err}`));
          }
        } else if (error.response.data.message) {
          this.$flash_warning(error.response.data.message);
        } else {
          this.$flash_warning('Произошла ошибка');
        }
      } else {
        this.$flash_warning('Произошла ошибка');
      }
    },
    getErrorMessage (error) {
      if (error.response && error.response.data) {
        if (error.response.data.message) {
          return error.response.data.message;
        }
      }
      return 'Ошибка.';
    },
    formatDate (date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('ru-RU');
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-radius: 16px;
}
.card-footer {
  margin-left: 10px;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.routerLink {
  background: none;
  border: none;
  color: blue;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}
</style>
